import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import Template from '../views/Template';

const CompoundPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <Template locale={locale} template="bnb" />
    </Layout>
  );
};

CompoundPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default CompoundPage;
